



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
	name: 'CheckBox'
})

export default class CheckBox extends Vue {
  @Prop({ default: 'checkbox-form' }) readonly label!: string
  @Prop({ default: false }) readonly required!: boolean
  @Prop({ default: 'text' }) readonly type!: string
  @Prop() readonly id!: string | number
	@Prop() readonly name!: string
	@Prop({ default: false }) readonly default!: boolean
	@Prop({ default: false }) readonly disabled!: boolean

	value = this.default

  @Watch('default', { deep: true, immediate: true })
  changeDefault () {
    if (this.value !== this.default) {
      this.value = this.default
    }
  }
}
